import React from "react";
import { denormalize } from "normalizr";
import { scaleLinear } from "d3-scale";

import Stack from "@mui/material/Stack";

import SquareIcon from "@mui/icons-material/Square";

import { TVehicle } from "types";
import { vehicleListSchema } from "schemas";

import { CatalogStore } from "stores";

import { checkQuality } from "components/EnVKV";

interface IHeatmap {
  vehicles: TVehicle[];
  onClickHandler?: any;
}

export const Heatmap: React.FC<IHeatmap> = ({
  vehicles,
  onClickHandler = () => null,
}) => {
  return (
    <Stack direction="row" useFlexGap sx={{ flexWrap: "wrap" }}>
      {vehicles.map((vehicle: TVehicle) => {
        return <Dot vehicle={vehicle} onClickHandler={onClickHandler} />;
      })}
    </Stack>
  );
};

interface IDot {
  vehicle: TVehicle;
  onClickHandler: any;
}
const color: any = scaleLinear()
  .domain([0, 0.5, 1])
  /* @ts-expect-error */
  .range(["#770000", "#aaaa00", "#007700"]);

const Dot: React.FC<IDot> = ({
  vehicle,
  onClickHandler = () => null,
}): JSX.Element => {
  const quality = checkQuality(vehicle);

  const rgbValue: string = color(quality.score);
  return (
    <SquareIcon
      onClick={() => onClickHandler(vehicle)}
      htmlColor={rgbValue}
      titleAccess={JSON.stringify(quality)}
    />
  );
};

interface IPipeline {
  onClickHandler?: any;
}

const Pipeline: React.FC<IPipeline> = ({
  onClickHandler = () => null,
}): JSX.Element | null => {
  const { state: NCatalog } = React.useContext(CatalogStore);
  if (!(NCatalog.entities && NCatalog.entities.vehicle)) return null;

  const vehicles: TVehicle[] = denormalize(
    NCatalog.result.vehicle,
    vehicleListSchema,
    NCatalog.entities
  );

  return <Heatmap vehicles={vehicles} onClickHandler={onClickHandler} />;
};

export default Pipeline;
